// Generic API response interface
export interface ApiResponse<T> {
  success: boolean;
  data: T;
  total?: number;
  timestamp: string;
  message?: string;
  error_code?: string;
  status?: string;
}

// API Error type to preserve error response structure
export class ApiError extends Error {
  status: number;
  data?: any;
  error_code?: string;

  constructor(status: number, message: string, error_code?: string, data?: any) {
    super(message);
    this.status = status;
    this.data = data;
    this.error_code = error_code;
  }
}
